export default "/assets/zendesk_envelope-dad357907c150572351deaf80b170f031a7e2c4bf59e83de63e57ad9e4d9919d.svg";